/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getFacilityEvents } from "../../../../../app/modules/auth/redux/AuthCRUD";
import { CurrentDateToGivenTimeCalculation } from "../../../../helpers/components/TimeDifferenceCalculate";
import { useRefresh } from "../../../../layout/components/ThemeProvider/RefreshButton";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import moment from "moment";
import Select, { ActionMeta, SingleValue } from "react-select";
import { SelectStyle } from "../../../../helpers/components/SelectStyle";

type Equipment = {
    equipment_id: string;
    equipment_name: string;
  };
  
  type Props = {
    className: string;
    facilityId: string;
    equipments: Equipment[];
  };
  interface EVENT {
    epoch: number;
    equipment_id: string;
    equipment_name: string;
    event_name: string;
    facility_name: string;
    time: string;
    file_id : string ;
}

interface Option {
    value: string;
    label: string;
}

const RecentEvent: React.FC<Props> = ({
    className,
    facilityId,
    equipments,
}) => {
      const history = useHistory();
    let equipmentOptions: Option[] = [
        ...equipments?.map((equipment) => ({
            value: equipment.equipment_id,
            label: equipment.equipment_name,
        })) ,
        { value: '', label: 'Clear All' }
      ];
    const [selectedEquipment, setSelectedEquipment] = useState<SingleValue<Option>>(null); 
     const isAuthorized = useSelector(({ auth }: any) => auth.accessToken);
    const { refresh, makeRefresh } = useRefresh();
    const [events, setEvents] = useState([]);
    const [offset, setOffset] = useState(0);
    const [totalEvents, setTotalEvents] = useState(0);
    const [startPage, setStartPage] = useState(0);
    const limit = 10;
    const displayedPages = 8;

    useEffect(() => {
        if (facilityId) {
          getFacilityEvents(
            isAuthorized,
            facilityId,
            limit,
            offset,
            selectedEquipment?.value ?? ""
          )
            .then(({ data }) => {
              setEvents(data.data);
              if (data.data && data.data.length > 0) {
                setTotalEvents(data.data[0].total_count);
              }
            })
            .catch(() => console.log("Events not found"));
        }
      }, [facilityId, refresh, selectedEquipment, offset]);



    const EventTime = ( time : string ) : string => {
        return ` ${moment(time).format('MMM D, YYYY HH:mm:ss')} (${CurrentDateToGivenTimeCalculation(time)}) `
    }

    const handleChange = (
        selectedOption: SingleValue<Option>,
        _: ActionMeta<Option>
      ) => {
        setSelectedEquipment(selectedOption);
        setOffset(0);
        setStartPage(0);
      };
    
      const handleNext = () => {
        if (offset + limit < totalEvents) {
          setOffset(offset + limit);
          if (currentPage + 1 >= startPage + displayedPages) {
            setStartPage(startPage + displayedPages);
          }
        }
      };
    
      const handlePrev = () => {
        if (offset > 0) {
          setOffset(offset - limit);
          if (currentPage <= startPage) {
            setStartPage(Math.max(0, startPage - displayedPages));
          }
        }
      };
    
      const handlePageClick = (page: number) => {
        setOffset(page * limit);
      };
      const totalPages = Math.ceil(totalEvents / limit);
      const currentPage = offset / limit;

    return (
        <div className={`card ${className}`}>
            {/* begin::Header */}
            <div className="card-header border-0 pt-5">
                <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder fs-1 mb-1">Recent Events</span>
                    {/* <span className='text-muted mt-1 fw-bold fs-7'>More than 10 new Events</span> */}
                </h3>
                <div className="d-flex  mt-2">
                                <Select
                                placeholder="Filter Equipment"
                                styles={SelectStyle}
                                className="fs-8 ms-2 react-select-dropdown"
                                defaultValue={selectedEquipment}
                                onChange={handleChange}
                                options={equipmentOptions}
                                />

                            </div>
            </div>
            {/* end::Header */}
            {/* begin::Body */}
            <div className="card-body py-3">
                <div className="tab-content">
                    {/* begin::Tap pane */}
                    <div
                        className="tab-pane fade show active"
                        id="kt_table_widget_5_tab_1"
                    >
                        {/* begin::Table container */}
                        <div className="table-responsive">
                            {/* begin::Table */}
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
                                {/* begin::Table head */}
                                <thead>
                                    <tr className="border-0 fs-5 ">
                                        <th className=" py-0 pe-2 text-muted text-nowrap fw-bolder">Sr No.</th>

                                        <th className="p-0 text-muted fw-bolder">Equipment</th>
                                        <th className="p-0  text-muted fw-bolder">Event</th>
                                        <th className="p-0 text-muted text-center fw-bolder">Timestamp</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                {/* end::Table head */}
                                {/* begin::Table body */}
                                <tbody>
                                    {events?.map((event: EVENT, index) => (
                                        <tr key={index} >
                                            <td className=" text-muted fw-bold">{index + 1}</td>

                                            <td className="ps-0 fw-bold text-muted">
                                                {/* <a href='#' className='text-dark fw-bold text-hover-primary mb-1 fs-6'> */}
                                                {event?.equipment_name}
                                                {/* </a> */}
                                                {/* <span className='text-muted fw-bold d-block'>Description</span> */}
                                            </td>
                                            <td className=" text-muted fw-bold ps-0">
                                                {event?.event_name}
                                            </td>

                                            <td className="ps-0 text-center  " data-bs-toggle="tooltip" data-bs-placement="top" title={(new Date(event?.time)).toLocaleString()}  >
                                                {/* <Tooltip title={(new Date(event?.time)).toLocaleString()} placement="top"> */}

                                                <span className="text-muted fw-bold ">
                                                    {EventTime(event?.time)}
                                                </span>
                                                {/* </Tooltip> */}
                                            </td>
                                            <td>
                                            <Button
                                                variant="contained"
                                                className="plotEventBtn"
                                                onClick={() => {
                                                    history.push(
                                                        `/dashboard/equipmentname/${event?.equipment_name}/equipment/${event?.equipment_id}/file/${event?.file_id}`
                                                    );
                                                }}
                                                >
                                                Plot
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                {/* end::Table body */}
                            </table>
                        </div>
                        {/* end::Table */}
                    </div>
                    {/* end::Tap pane */}
                    {/* begin::Tap pane */}
                    <div className="d-flex justify-content-between align-items-center mt-4">
            <div>
              <button
                className="carousel-control-prev position-relative"
                type="button"
                onClick={handlePrev}
                disabled={offset === 0}
              >
                <span
                  className="carousel-control-prev-icon bg-dark"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
            </div>
            <div className="d-flex align-items-center gap-1 ">
              {Array.from({
                length: Math.min(displayedPages, totalPages - startPage),
              }).map((_, index) => {
                const pageIndex = startPage + index;
                return (
                  <button
                    key={pageIndex}
                    className={`btn ${
                      pageIndex === currentPage ? "btn-primary" : "btn-light"
                    }`}
                    onClick={() => handlePageClick(pageIndex)}
                  >
                    {pageIndex + 1}
                  </button>
                );
              })}
            </div>
            <div>
              <button
                className="carousel-control-next position-relative"
                type="button"
                onClick={handleNext}
                disabled={offset + limit >= totalEvents}
              >
                <span
                  className="carousel-control-next-icon bg-dark"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>


                    {/* end::Tap pane */}
                    {/* begin::Tap pane */}

                    {/* end::Tap pane */}
                </div>
                {
                    events?.length == 0 &&
                    <div className='text-muted no-content py-3'>No Recent Events</div>
                }

            </div>
            {/* end::Body */}
        </div>
    );
};

export { RecentEvent };
